module.exports = __webpack_public_path__ + "img/213825268_984450749038539_78981189920489155_n.2b9c2aad.jpg";